<!------------------------------------------------------------------------------
  Copyright (c) 2018. keni <$email>

  This file CardsVisa.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  CardsVisa.vue can not be copied and/or distributed
  without the express permission of keni
  ----------------------------------------------------------------------------->

<!------------------------------------------------------------------------------
 File: CardsVisa 
 Created by keni.
 with: IntelliJ IDEA
 Date: 27/04/2018
 Time: 14:52
------------------------------------------------------------------------------->
<template>
    <div>
        <i v-if="card.brand === 'Visa'"
                class="fa-cc-visa"
                :class="fa"
        ></i>
        <i v-else-if="card.brand === 'MasterCard'"
                class="fa-cc-mastercard "
                :class="fa"
        ></i>
        <i v-else-if="card.brand === 'Discovery'"
                class="fa-cc-discover "
                :class="fa"
        ></i>
        <i v-else-if="card.brand === 'JCB'"
                class="fa-cc-jcb "
                :class="fa"
        ></i>
        <i v-else class="fa-credit-card "
                :class="fa"
        ></i>
    </div>
</template>

<script>
	export default {
		name: "cards-visa",
		components: {},
		props: {
			/**
             * @param {String} card.brand
             * @param {Object} card
			 */
			card:{
				type: Object,
            }
        },
		created() {
		},
		destroyed() {
		},
		mounted() {

		},
		data() {
			return {
				fa: 'fa fs-15'
			}
		},
		methods: {},
		watch: {},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/cards/CardsVisa.vue